import { ConnectionOptions, GraphApiMethod } from '@/api/core';
import { DeleteDispatchSummaryInput, DeleteDispatchSummaryBulkResponse, MutationDeleteDispatchSummaryBulkArgs } from '@/models/gen/graphql';
import createGraphApiHook, { CreateGraphApiHookHook } from '@/hooks/createGraphApiHook';

import { TypedDocumentNode } from '@apollo/client';
import { getProperty } from '@/utils';
import graphApi from '@/api';
import { DeleteDispatchSummary } from '@/features/SummaryHistory/api/queries/DeleteDispatchSummary';

// Service Function Signature
type ServiceMethodPayload = {
  [key in keyof DeleteDispatchSummaryInput]?: any;
}[];
interface ServiceMethod {
  (payload?: ServiceMethodPayload, options?: ConnectionOptions): Promise<DeleteDispatchSummaryBulkResponse>;
}

// DeleteDispatchSummary Service
export const { deleteDispatchSummary, useDeleteDispatchSummary } = ((): {
  deleteDispatchSummary: ServiceMethod;
  useDeleteDispatchSummary: CreateGraphApiHookHook<ServiceMethod>;
} => {
  const [fetch] = graphApi(DeleteDispatchSummary).map(
    (fn: GraphApiMethod<TypedDocumentNode>): ServiceMethod =>
      async (payload?: DeleteDispatchSummaryInput[], options?: ConnectionOptions): Promise<DeleteDispatchSummaryBulkResponse> => {
        const args: MutationDeleteDispatchSummaryBulkArgs = {
          input: {
            search: payload,
          },
        };
        const opts = { merge: options?.merge ? 'deleteDispatchSummaryBulk' : undefined };
        const res = await fn(args, opts);
        return getProperty('deleteDispatchSummaryBulk', res);
      }
  );
  const useService = createGraphApiHook(fetch);
  return {
    deleteDispatchSummary: fetch,
    useDeleteDispatchSummary: useService,
  };
})();
